import { Route } from 'react-router-dom';
import { lazy } from 'react';

const NotificationDetailsPage = lazy(() => import('../features/notifications/components/NotificationDetailsPage'));
const PaymentSuccess = lazy(() => import('../features/payment/PaymentSuccess'));
const PaymentCancel = lazy(() => import('../features/payment/PaymentCancel'));
const FeedsPage = lazy(() => import('../features/feed/FeedsPage'));
const PaymentRouteWrapper = lazy(() => import('../features/payment/PaymentWrapper'));
const MessagesPage = lazy(() => import('../features/messages/MessagesPage'));
const NotificationsPage = lazy(
  () => import('../features/notifications/NotificationsPage')
);
const SupportPage = lazy(() => import('../features/support/SupportPage'));

export default function SharedRoutes() {
  return (
    <>
      <Route path="/messages" element={<MessagesPage />} />
      <Route path="/messages/:otherUserId" element={<MessagesPage />} />
      <Route
        path="/booking/:bookingId/:userId"
        element={<NotificationDetailsPage />}
      />
      <Route path="/notifications" element={<NotificationsPage />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-cancel" element={<PaymentCancel />} />
      <Route path="/feed" element={<FeedsPage />} />
      <Route path="/payment/:bookingId" element={<PaymentRouteWrapper />} />
      <Route path="/support" element={<SupportPage />} />
    </>
  );
}
